import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolActivityBasename } from "../tool-activity-basename";
import { toolInput } from "../tool-input";

export function describeNativePatch(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const path = toolActivityBasename(toolInput.str(record.path));
  const count = Array.isArray(record.changes) ? record.changes.length : 0;
  const target =
    path ?? (count > 0 ? `${count} file${count === 1 ? "" : "s"}` : "files");
  const verb = state.hasFailed
    ? "Failed to edit"
    : state.isRunning
      ? "Editing"
      : "Edited";
  return labelOnly(`${verb} ${target}`);
}
